import PropTypes from 'prop-types'; import React from 'react';
import { ButtonGroup, Col, Form, InputGroup, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../shared/components/Button';
import OauthButton from '../../../../../shared/components/OauthButton/OauthButton';
import Checkbox from '../../../../../shared/components/Checkbox/Checkbox';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FormControl from '../../../../../shared/components/Form/FormControl';
import { useSelector } from 'react-redux';

const LOCALES_PATH = 'influencers.pages.campaign.apply_side_pane.facebook_connect.';

const validationSchema = Yup.object().shape({
  handleAgreement: Yup.boolean().required().oneOf([true]),
  connectedToFacebookAgreement: Yup.boolean().required().oneOf([true]),
  userHandle: Yup.string().required(),
});

const RequiredInstagramOAuth = ({
  onRequestClose,
}) => {
  const { t } = useTranslation();
  const testFlow = useSelector(state => state.config.test);

  const formik = useFormik({
    initialValues: {
      handleAgreement: false,
      connectedToFacebookAgreement: false,
      userHandle: null
    },
    validationSchema,
    onSubmit: values => {
      console.log(values);
    },
  });

  return <div>
    <h3>
      {t(`${LOCALES_PATH}required.title`)}
    </h3>

    <div className='mb-4 text-1'>
      {t(`${LOCALES_PATH}required.subtitle`)}
    </div>

    {/* <h5 className="mb-3">
      {t(`${LOCALES_PATH}confirm_instagram_handle`)}
    </h5> */}

    <Form>
      <Form.Group className="mb-4">
        <Form.Label>
          {t(`${LOCALES_PATH}confirm_instagram_handle`)}
        </Form.Label>
        <FormControl type="text"
          name="userHandle"
          onChange={formik.handleChange}
          autoComplete="off"
        />
      </Form.Group>

      <InputGroup className="mb-3">
        <Checkbox
          name="handleAgreement"
          onChange={formik.handleChange}
          value={formik.values.handleAgreement}
          label={
            <span className="text-1">
              <div>
                {t(`${LOCALES_PATH}checkbox_handle`)}
              </div>
              <Button
                className="p-0"
                variant="link"
                href="https://www.facebook.com/business/help/502981923235522"
                target="_blank">
                {t(`${LOCALES_PATH}how_do_i_do_this`)}
              </Button>
            </span>
          }
        />
      </InputGroup>

      <InputGroup className="mb-3">
        <Checkbox
          name="connectedToFacebookAgreement"
          onChange={formik.handleChange}
          value={formik.values.connectedToFacebookAgreement}
          label={
            <span className="text-1">
              <div>
                {t(`${LOCALES_PATH}checkbox_facebook_page`)}
              </div>
              <Button
                className="p-0"
                variant="link"
                href="https://www.facebook.com/business/help/898752960195806"
                target="_blank"
              >
                {t(`${LOCALES_PATH}how_do_i_do_this`)}
              </Button>
            </span>
          }
        />
      </InputGroup>

    </Form>
    <hr className='my-3' />
    <Row className='justify-content-end'>
      <Col className="col-auto">
        <ButtonGroup className="non-adaptable">
          <Button
            variant="secondary"
            type="button"
            onClick={() => onRequestClose()} >
            {t('influencers.common.cancel')}
          </Button>
          {
            testFlow.includes('fb_required')
              ? <Button disabled={!formik.isValid}
                variant='primary'
                onClick={() => {
                  const { origin, pathname } = window.location;
                  const queryParams = new URLSearchParams({
                    'facebook_oauth_callback': testFlow.includes('fb_success'),
                    'test_flow': `fb_required${testFlow.includes('fb_success') ? ',fb_success' : ',fb_error'}${testFlow.includes('yt') ? ',yt' : ''}`
                  });
                  window.location.replace(`${origin}${pathname}?${queryParams.toString()}`);
                }}>
                {t('influencers.common.connect')}
              </Button>
              : <OauthButton platform="facebook"
                disabled={!formik.isValid}
                text={t('influencers.common.connect')} />
          }
        </ButtonGroup>
      </Col>
    </Row>
  </div>;
};

RequiredInstagramOAuth.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  lastStep: PropTypes.func.isRequired
};
export default RequiredInstagramOAuth;